import React from 'react';
import noop from 'utils/noop';
import { CriteriaTextInput } from './CriteriaPropertyField.styled';

// type Props = {
//   /** Class of the text field. */
//   className: string,
//   /** If the text field is disabled. */
//   disabled: boolean,
//   /** If the field has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** If the field is dynamic. */
//   isDynamic: boolean,
//   /** Callback function when field value is changed. */
//   onChange: () => {},
//   /** Placeholder test of the field. */
//   placeholder: string,
//   /** The value of the field. */
//   value: string,
// };

export default class CriteriaTextField extends React.Component {
  static defaultProps = {
    fieldIdentifier: [],
    onChange: noop,
    disabled: false,
  };

  /**
   * handleChange
   * Callback function when value changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: Updated props containing updated value.
   * @returns { void }
   */
  handleChange = (e, { value }) => {
    const { fieldIdentifier, onChange } = this.props;
    onChange(value, ...fieldIdentifier);
  };

  render() {
    const { className, disabled, error, placeholder, value } = this.props;

    return (
      <CriteriaTextInput
        className={className}
        data-test="criteria-text-input"
        disabled={disabled}
        error={error}
        onChange={this.handleChange}
        placeholder={placeholder}
        value={value}
      />
    );
  }
}
